import script from "./BankCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankCard.vue?vue&type=script&setup=true&lang=ts"

import "./BankCard.vue?vue&type=style&index=0&id=6dee5912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dee5912"]])

export default __exports__